import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from '@/router'
import AppNavigationItems from './AppNavigationItems.vue'

const LS_EXPAND_KEY = 'sennTMS_navbar_expand'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutSidebar',
  setup(__props) {

const expanded = Boolean(localStorage.getItem(LS_EXPAND_KEY))

const onCollapse = () => {
  localStorage.removeItem(LS_EXPAND_KEY)
}

const onExpand = () => {
  localStorage.setItem(LS_EXPAND_KEY, 'true')
}

const navigate = (e: CustomEvent) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
}

const onLogoClick = () => {
  router.push({ path: '/' })
}

return (_ctx: any,_cache: any) => {
  const _component_dsf_navbar = _resolveComponent("dsf-navbar")!

  return (_openBlock(), _createBlock(_component_dsf_navbar, {
    dsf_collapsed: !_unref(expanded),
    dsf_title: _ctx.$t('navigation.title.expanded'),
    dsf_collapsed_title: _ctx.$t('navigation.title.collapsed'),
    dsf_collapse_text: _ctx.$t('navigation.item.collapse'),
    dsf_expand_text: _ctx.$t('navigation.item.expand'),
    onNavigate: navigate,
    onExpand: onExpand,
    onCollapse: onCollapse,
    onLogoClick: onLogoClick,
    class: "nav-bar"
  }, {
    default: _withCtx(() => [
      _createVNode(AppNavigationItems)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["dsf_collapsed", "dsf_title", "dsf_collapsed_title", "dsf_collapse_text", "dsf_expand_text"]))
}
}

})